export { RATE_LIMITED_MESSAGE, SUPPORT_EMAIL }

// Single source for the "too many requests" copy, shared across the sign-in form, the
// authenticated dashboard actions, and the free-trial endpoint — previously each phrased it
// differently. env-agnostic (a plain string) so both client and server import it.
const RATE_LIMITED_MESSAGE = 'Too many requests — please wait a minute and try again.'

// Customer-facing support address — appears in the email `from:`, an email body, the footer, the
// sign-in screen, and the over-limit hint. Centralized like the operator alert addresses
// (`ERROR_TRACKING_EMAIL` / `REFUND_TRACKING_EMAIL` in `handleStripeWebhook.ts`) so it lives once;
// env-agnostic so client + server share it.
const SUPPORT_EMAIL = 'support@vike.dev'
